import { useSearchFiltersStore } from '@aibees/elephant/feature/search-filters/store';
import { useMemo, useState } from 'react';
import { useBrowseCompanyEmployees } from './use-browse-company-employees';

export function useEmployeesData() {
  const companyId = useSearchFiltersStore((state) => state.selectedItemId);
  const [searchTerm, setSearchTerm] = useState('');

  const { data, isLoading } = useBrowseCompanyEmployees(
    {
      page: 0,
      size: 10,
      data: { company_id: companyId },
    },
    {
      enabled: !!companyId,
    }
  );

  const filteredData = useMemo(() => {
    if (!searchTerm) return data?.content;

    return data?.content?.filter((item) => {
      const personName = item?.profile?.full_name?.toLowerCase();
      return personName && personName.includes(searchTerm.toLowerCase());
    });
  }, [data, searchTerm]);
  const emptyData = filteredData?.length === 0;

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  return { filteredData, emptyData, isLoading, handleSearch };
}
